import React from "react";
import { Tooltip } from "@mantine/core";
import { useAIInsightsChat } from "../providers/AIInsightsChatProvider";
import jemInsightsIcon from "../../../assets/jem-insights-icon.png";

const AIInsightsFloatingButton: React.FC = () => {
  const { openChat, isOpen } = useAIInsightsChat();

  // Don't show button if chat is already open
  if (isOpen) return null;

  return (
    <Tooltip label="Ask Jem AI" position="left" withArrow>
      <button
        onClick={openChat}
        className="fixed bottom-6 right-6 shadow-2xl hover:scale-110 transition-transform duration-200 z-50 cursor-pointer border-0 bg-transparent p-0"
        style={{
          width: "64px",
          height: "64px",
        }}
        type="button"
        aria-label="Open AI Insights Chat"
      >
        <img
          src={jemInsightsIcon}
          alt="Jem AI Insights"
          className="w-full h-full"
        />
      </button>
    </Tooltip>
  );
};

export default AIInsightsFloatingButton;
